export const environment = {
  api: "https://safi-ibrahim.thats.im/api/v1/",
  storage: "https://safi-ibrahim.thats.im/storage/",
  // api: "http://127.0.0.1:8000/api/v1/",
  // storage: "http://127.0.0.1:8000/storage/",
};
